import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const affirmationProgramImporterSelectors = importerSelectors(
  'affirmationProgram.importer',
);

export default affirmationProgramImporterSelectors;
